import { EcoState } from '../context';

/**
 * Rule type enum
 */
export const RULE_TYPES = {
    COUPONS: 'COUPONS',
    FREE_PRODUCTS: 'FREE_PRODUCTS',
    THIRD_COUPONS: 'THIRD_COUPONS',
    GIFT_CARD: 'GIFT_CARD',
} as const;

export type RuleType = (typeof RULE_TYPES)[keyof typeof RULE_TYPES];

/**
 * Module tab interface
 */
export interface ModuleTab {
    key: keyof EcoState;
    label: string;
}

/**
 * Rule props interface
 */
export interface RuleProps {
    title: string;
    subTitle: string;
    pathUrl: string;
    setShowPage: (page: string) => void;
    refershData: () => void;
    modal?: boolean;
    defauleActiveTab?: string;
    bgColor?: string;
    customColor: Record<string, string | undefined>;
    isEditStatus?: boolean;
    id?: string;
    customStyle?: Record<string, string>;
    loginType?: 'page' | 'modal';
}

/**
 * Coupon/Rule item interface
 */
export interface CouponRule {
    ruleId: string;
    version: string;
    ruleType: RuleType;
    points: number;
    stock?: number;
    stockPicEnable?: boolean;
    thirdUrl?: string;
    jumpUrl?: string;
    useUrl?: string;
    noteList?: string[];
    ruleWebsite?: {
        version: string;
    };
    campaignId?: string;
    campaignVersion?: string;
    coupon?: string;
    [key: string]: any;
}

/**
 * Redeem params interface
 */
export interface RedeemParams {
    ruleId: string;
    ruleVersion: string;
    ruleSiteVersion?: string;
    campaignVersion?: string;
    address?: any;
}

/**
 * API response interface
 */
export interface ApiResponse<T = any> {
    code: string;
    message?: string;
    data?: T;
}

/**
 * Eco store state from context
 */
export interface EcoStoreState {
    rewardUserInfo?: {
        points: number;
        [key: string]: any;
    };
    [key: string]: any;
}

/**
 * Translation function type
 */
export type TranslationFn = {
    (key: string, params?: Record<string, any>): string;
    rich: (key: string, options: { code: (children?: string) => React.ReactNode; points?: string }) => React.ReactNode;
};
